// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__xZi8M","gfeWrapper":"CalendarEvent_gfeWrapper__sjU9R"};